import React from "react";
import ReactECharts from "echarts-for-react";

function EChart({
  option,
  height = "100%",
  loading = false,
}) {
  return (
    <div style={{ width: "100%", maxWidth: "100%", minWidth: 0, height, overflow: "hidden" }}>
      <ReactECharts
        option={option}
        showLoading={loading}
        notMerge={true}
        lazyUpdate={true}
        opts={{ renderer: "canvas" }}
        style={{ width: "100%", maxWidth: "100%", height }}
      />
    </div>
  );
}

export default EChart;